import React, { useEffect, useState } from 'react';
import { Table, TableRow } from '@material-ui/core';
import Forms from 'components/Forms';
import TableComponents from 'components/Table';
import {
  sumFunds,
  sumTotalOngoing,
  sumTransferValue,
  formatCurrency,
  formatPercent
} from 'utils';
import Store from 'store/store';

const { connect, selectors } = Store;

interface PortfoliosTypes {
  fields: any;
  portfolioRiskScore: any;
  caseInfo: any;
}

const Portfolios = ({
  fields,
  portfolioRiskScore,
  caseInfo
}: PortfoliosTypes) => {
  const isEvalue = caseInfo.riskProfiler === 'EValue';
  const riskHeaders = isEvalue
    ? ['Risk']
    : ['Growth assets', 'Risk comfort score'];
  const [riskScore, setRiskScore] = useState('' as any);
  const policies = fields.getAll();

  useEffect(() => {
    const portfolioRiskProfile = portfolioRiskScore.find(
      (score: any) => score.name === 'Existing'
    );

    if (portfolioRiskProfile) {
      setRiskScore(portfolioRiskProfile.risk_score);
    }
  }, [portfolioRiskScore]);

  const sumTotalOngoingCharges = sumTotalOngoing(policies);
  const transferValuesSum = sumTransferValue(policies);
  const fundsSum = sumFunds(policies);
  const totalOngoingCharge = sumTotalOngoingCharges / fundsSum;

  return (
    <>
      <Table style={{ backgroundColor: '#fff' }}>
        <TableComponents.TableHead
          cells={[
            'Policy owner(s)',
            'Platform',
            'Policy provider',
            'Policy type',
            'Fund value',
            'Transfer value',
            'Total ongoing charge',
            ...riskHeaders,
            'Action'
          ]}
        />
        <TableComponents.TableBody>
          {fields.map((cell: string, index: number) => {
            const fieldValues = fields.get(index);
            return (
              <Forms.Policy
                policy={cell}
                key={index}
                policyId={fieldValues.id}
                isProcessed={fieldValues.isProcessed}
                transferValue={fieldValues.transfer_value}
                performedAction={fieldValues.performed_action}
                morningstarRiskAnalysis={fieldValues.morningstar_risk_analysis}
                isEvalue={isEvalue}
              />
            );
          })}
        </TableComponents.TableBody>
        <TableComponents.TableFooter>
          <TableRow>
            <TableComponents.TableCell />
            <TableComponents.TableCell />
            <TableComponents.TableCell />

            <TableComponents.TableCell>Overall</TableComponents.TableCell>
            <TableComponents.TableCell>
              {formatCurrency(fundsSum)}
            </TableComponents.TableCell>
            <TableComponents.TableCell>
              {formatCurrency(transferValuesSum)}
            </TableComponents.TableCell>
            <TableComponents.TableCell>
              {formatPercent(totalOngoingCharge ? totalOngoingCharge * 100 : 0)}
            </TableComponents.TableCell>
            {isEvalue ? (
              <TableComponents.TableCell>
                {riskScore || '-'}
              </TableComponents.TableCell>
            ) : (
              <>
                <TableComponents.TableCell>
                  {formatPercent(riskScore.growth_score)}
                </TableComponents.TableCell>
                <TableComponents.TableCell>
                  {`${riskScore.range?.low} - ${riskScore.range?.high}`}
                </TableComponents.TableCell>
              </>
            )}
            <TableComponents.TableCell />
          </TableRow>
        </TableComponents.TableFooter>
      </Table>
    </>
  );
};

export default connect((state: any) => ({
  portfolioRiskScore: selectors.caseSelectors.portfolioRiskScore(state),
  caseInfo: selectors.caseSelectors.case(state)
}))(Portfolios);
